import { cn } from '@/lib/utils'
import { Loader2Icon } from 'lucide-react'

interface CircularProgressProps {
    className?: string
    /** Diâmetro em px (number) ou unidade CSS (string). Padrão 40. */
    size?: number | string
    color?: 'primary' | 'inherit'
    /**
     * Progresso de 0 a 100. Quando informado o anel é determinado (arco
     * proporcional); sem ele o indicador é indeterminado (ícone girando).
     */
    value?: number
}

const RAIO = 18
const PERIMETRO = 2 * Math.PI * RAIO

export default function CircularProgress({
    className,
    size = 40,
    color = 'primary',
    value,
}: CircularProgressProps) {
    const cor = color === 'inherit' ? 'text-current' : 'text-primary'
    const dimensao =
        typeof size === 'string' ? { width: size, height: size } : undefined

    if (value !== undefined) {
        const preenchido = Math.min(100, Math.max(0, value))

        return (
            <svg
                role="progressbar"
                aria-valuenow={Math.round(preenchido)}
                aria-valuemin={0}
                aria-valuemax={100}
                viewBox="0 0 44 44"
                width={typeof size === 'number' ? size : undefined}
                height={typeof size === 'number' ? size : undefined}
                style={dimensao}
                className={cn('shrink-0 -rotate-90', cor, className)}
            >
                <circle
                    cx="22"
                    cy="22"
                    r={RAIO}
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="8"
                    strokeDasharray={PERIMETRO}
                    strokeDashoffset={PERIMETRO * (1 - preenchido / 100)}
                    className="transition-[stroke-dashoffset]"
                />
            </svg>
        )
    }

    return (
        <Loader2Icon
            role="progressbar"
            className={cn('animate-spin', cor, className)}
            size={typeof size === 'number' ? size : undefined}
            style={dimensao}
        />
    )
}
